var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeartFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.681641,
    y: 0.5,
    width: 28,
    height: 28,
    rx: 8,
    fill: "#ac2121ff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5148 16.1667C21.7565 14.95 23.0148 13.4917 23.0148 11.5833C23.0148 10.3678 22.5319 9.20197 21.6724 8.34243C20.8128 7.48289 19.6471 7 18.4315 7C16.9648 7 15.9315 7.41667 14.6815 8.66667C13.4315 7.41667 12.3981 7 10.9315 7C9.7159 7 8.55011 7.48289 7.69057 8.34243C6.83103 9.20197 6.34814 10.3678 6.34814 11.5833C6.34814 13.5 7.59814 14.9583 8.84814 16.1667L14.6815 22L20.5148 16.1667Z",
    stroke: "#9CA3AF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartFilled);
export default __webpack_public_path__ + "static/media/heartFilled.0beafa38a2dd7e98a12dda90ce78c1cb.svg";
export { ForwardRef as ReactComponent };